import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { MapService } from '../../services/map.service';
import './map.component.scss';
var Map = /** @class */ (function (_super) {
    tslib_1.__extends(Map, _super);
    function Map(element) {
        var _this = _super.call(this, element) || this;
        new MapService().init();
        _this.event.register('googleMapsReady', null, _this.initMap.bind(_this));
        return _this;
    }
    Map.prototype.init = function () {
        this.userOptions = JSON.parse(this.element.getAttribute('data-config'));
        this.mapOptions = {
            backgroundColor: '#FFF',
            center: {
                lat: -26.115976,
                lng: 28.046638
            },
            clickableIcons: true,
            draggable: true,
            fullscreenControl: true,
            gestureHandling: 'cooperative',
            scrollwheel: true,
            styles: [
                {
                    elementType: 'geometry',
                    featureType: 'water',
                    stylers: [
                        {
                            color: '#00BDBD'
                        }
                    ]
                },
                {
                    elementType: 'geometry',
                    featureType: 'landscape.man_made',
                    stylers: [
                        {
                            color: '#f7f1df'
                        }
                    ]
                }
            ],
            zoom: 4
        };
    };
    Map.prototype.bindEvents = function () { };
    Map.prototype.initMap = function () {
        var _this = this;
        this.mapConfig = Object.assign(this.mapOptions, this.userOptions.config);
        this.map = new google.maps.Map(this.element, this.mapConfig);
        google.maps.event.addDomListener(window, 'resize', function () { return _this.map.setCenter(_this.userOptions.center); });
        this.event.emit('mapInitialised', {
            map: this.map,
            options: this.userOptions
        });
    };
    return Map;
}(Base));
export { Map };



//////////////////
// WEBPACK FOOTER
// ./components/map/map.component.ts
// module id = 409
// module chunks = 0